import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  partners: [],
  selectedPartner: null,
  pagination: {
    current_page: 1,
    per_page: 10,
    total: 0,
    last_page: 1,
  },
  filters: {
    search: '',
    status: null,
  },
  loading: false,
  error: null,
};

const partnersSlice = createSlice({
  name: 'partners',
  initialState,
  reducers: {
    // Set partners list
    setPartners: (state, action) => {
      state.partners = action.payload.data;
      state.pagination = {
        current_page: action.payload.current_page,
        per_page: action.payload.per_page,
        total: action.payload.total,
        last_page: action.payload.last_page,
      };
    },

    // Set selected partner
    setSelectedPartner: (state, action) => {
      state.selectedPartner = action.payload;
    },

    // Update partner in list
    updatePartnerInList: (state, action) => {
      const index = state.partners.findIndex((p) => p.id === action.payload.id);
      if (index !== -1) {
        state.partners[index] = action.payload;
      }
      if (state.selectedPartner?.id === action.payload.id) {
        state.selectedPartner = action.payload;
      }
    },

    // Remove partner from list
    removePartnerFromList: (state, action) => {
      state.partners = state.partners.filter((p) => p.id !== action.payload);
      if (state.selectedPartner?.id === action.payload) {
        state.selectedPartner = null;
      }
    },

    // Set filters
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },

    // Set pagination
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },

    // Set loading
    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error
    setError: (state, action) => {
      state.error = action.payload;
    },

    // Clear error
    clearError: (state) => {
      state.error = null;
    },

    // Reset filters
    resetFilters: (state) => {
      state.filters = initialState.filters;
    },

    // Reset state
    resetPartners: () => initialState,
  },
});

export const {
  setPartners,
  setSelectedPartner,
  updatePartnerInList,
  removePartnerFromList,
  setFilters,
  setPagination,
  setLoading,
  setError,
  clearError,
  resetFilters,
  resetPartners,
} = partnersSlice.actions;

export default partnersSlice.reducer;